
import { RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getBusinessUnits } from "../../Requests/BusinessUnit.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([getBusinessUnits((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1]))), getAccountSettings((Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(2, [Item_3])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.BusinessUnits, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 2:
            return [state, Cmd_none()];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
    }
}

